import React, { useState, useEffect } from "react";
import styles from "./ProductsScreen.styles";
import { Grid, makeStyles, ThemeProvider } from "@material-ui/core";
import TablePagination from "@material-ui/core/TablePagination";
import TablePaginationActions from "../../components/common/pagination/TablePaginationActions";
import NewProductsWindow from "../../components/ModalWindows/NewProductWindow";
import theme from "../Login/LoginSreen.breakpoints";
import { shop } from "../../utils/api";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import ProductTable from "../../components/ProductTable/ProductTable";
import ErrorSnackBar from "../../components/Snackbar/ErrorSnackBar";
import CircularProgress from "@material-ui/core/CircularProgress";
import StyledFormTextField from "../../components/common/textFields/StyledFormTextField";
import { Redirect } from "react-router-dom";
import ListHeader from "../../components/common/ListHeader";

import { ERROR_MESSAGES } from "../../constants/dictionary";

const useStyles = makeStyles(styles);

const Products = () => {
  const [products, setProducts] = useState([]);
  const [productsCopy, setProductsCopy] = useState([]);
  const classes = useStyles();
  const [open, setOpen] = useState(false);
  const matches = useMediaQuery(theme.breakpoints.down("sm"));
  const [error, setError] = useState(false);
  const [isLoaded, setIsLoaded] = useState(false);
  const [errorText, setErrorText] = useState("");
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);

  const handleError = (text) => {
    setErrorText(text);
    setError(true);
  };

  useEffect(() => {
    shop.articles
      .all()
      .then((products) => {
        let origin = new URL(products.config.url).origin;
        products.data.articles.map((article) => {
          let repairedImages = [];
          article.images.map((image) => {
            let pathname = new URL(image).pathname;
            repairedImages.push(origin + pathname);
          });
          article.images = repairedImages;
        });
        let sorted = products.data.articles
          ? products.data.articles.sort((a, b) => b.id - a.id)
          : [];
        setProducts(sorted);
        setProductsCopy(sorted);
        setIsLoaded(true);
      })
      .catch((err) => {
        if (err?.response?.status && err?.response?.status === 401) {
          <Redirect
            to={{
              pathname: "/login",
            }}
          />;
        }
        handleError(ERROR_MESSAGES.COULD_NOT_CONNECT_TO_SERVER);
      });
  }, []);

  const handleChange = (e) => {
    if (e.target.value !== "") {
      const res = productsCopy.filter((product) => {
        return (
          product.name &&
          product.name.toLowerCase().startsWith(e.target.value.toLowerCase())
        );
      });
      setProducts(res);
      setPage(0);
    } else {
      setProducts(productsCopy);
    }
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  return (
    <ThemeProvider theme={theme}>
      {isLoaded ? (
        <Grid container>
          <ListHeader
            variant="title-add-search"
            title="Lista produktów"
            handleAdd={() => setOpen(true)}
            searchComponent={
              <StyledFormTextField
                InputLabelProps={{ classes: { root: classes.label } }}
                name="name"
                fullWidth={matches}
                label="Szukaj Produktu"
                variant="outlined"
                shrink="true"
                onChange={(e) => handleChange(e)}
              />
            }
          />
          <Grid container>
            <Grid item xs={12} align="center">
              <ProductTable
                products={products}
                setProducts={setProducts}
                page={page}
                rowsPerPage={rowsPerPage}
                handleError={handleError}
              />
              <TablePagination
                rowsPerPageOptions={[10, 15, 20, 50]}
                component="div"
                count={products.length}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignContent: "center",
                }}
                classes={{
                  toolbar: classes.toolbar,
                  caption: classes.caption,
                }}
                ActionsComponent={TablePaginationActions}
                labelRowsPerPage={"Ilość wierszy na stronę"}
                labelDisplayedRows={({ from, to, count }) => {
                  return `${from}–${to} z ${
                    count !== -1 ? count : `więcej niż ${to}`
                  }`;
                }}
              />
            </Grid>
          </Grid>
          <NewProductsWindow
            isOpen={open}
            close={() => setOpen(false)}
            handleError={handleError}
          />
        </Grid>
      ) : (
        <div className={classes.container}>
          <CircularProgress color="secondary" className={classes.loader} />
        </div>
      )}
      <ErrorSnackBar
        open={error}
        text={errorText}
        close={() => setError(false)}
      />
    </ThemeProvider>
  );
};

export default Products;
